
export default {
  name: 'FaqSchemaGenerator',
  data() {
    return {
      faqList: [
        { question: '', answer: '' } // Default FAQ item
      ],
      generatedSchema: null,
    };
  },
  methods: {
    addFaq() {
      this.faqList.push({ question: '', answer: '' });
    },
    removeFaq(index) {
      if (this.faqList.length > 1) {
        this.faqList.splice(index, 1);
      }
    },
    onFaqSchemaGenerator() {
      const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": this.faqList.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      };

      this.generatedSchema = JSON.stringify(faqSchema, null, 2);
    },
    onSample() {
      this.faqList = [
        { question: 'What is Lorem Ipsum?', answer: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.' }
      ];
    },
    onReset() {
      this.faqList = [{ question: '', answer: '' }];
      this.generatedSchema = null;
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
};
